import "../layouts/default"
import './account-jquery'

import '../ui/slider'
import '../ui/more-items'
import '../ui/horizontal-scroll'

import Swiper, { Navigation } from 'swiper';
import { initDatepickers } from '../functions/datepicker'

Swiper.use([Navigation]);
initDatepickers()

function toggleRegisterWarning(show) {
    const warning = document.getElementById('b2b-register-warning');

    if (warning) {
        warning.classList.toggle('is-hidden', !show);
    }
}

rEvent.on("Finstat.select.after", function (elem, data) {
    toggleRegisterWarning(data.result.length < 1 ? true : false);
});
rEvent.on("Finstat.orgNum.after", function (elem, data) {
    toggleRegisterWarning(data.result.length < 1 ? true : false);
});

rEvent.on("Finstat.select.error", function (elem, data) {
    toggleRegisterWarning(true);
});
rEvent.on("Finstat.source.error", function (elem, data) {
    toggleRegisterWarning(true);
});
rEvent.on("Finstat.orgNum.error", function (elem, data) {
    toggleRegisterWarning(true);
});